
























































































import {defineComponent, onBeforeUnmount, ref} from "@vue/composition-api"
import {GameName} from "./types"
import io from "socket.io-client"
import MemoryGame from "@/games/flashcards/memory-game/MemoryGame.vue"
import Scribble from "@/games/scribble/Scribble.vue"

type Socket = typeof io.Socket

export default defineComponent({
  name: "GameScreen",
  components: {
    Scribble,
    MemoryGame,
  },
  props: {
    roomId: {
      type: String,
      required: true
    },
    playerId: {
      type: String,
      required: true
    },
    socket: {
      type: Object as () => Socket,
      required: true
    },
    windowOrientation: {
      type: String,
      required: true
    }
  },
  setup({socket}) {
    const gameName = ref<GameName | undefined>()

    socket.on('game : start', (game: GameName) => gameName.value = game)

    onBeforeUnmount(() => {
      socket.off('game : start')
    })

    return {
      GameName,
      gameName,
      voteForGame(gameName: string) {
        socket.emit('vote', {action: 'game : start', on: gameName})
      },
    }
  }
})
